module.exports = __webpack_public_path__ + "static/media/il.ae87b7c6.webp";